import Button from '@/shared/components/Button';
import {Box, Typography} from '@mui/material';
import {forgotPasswordModalStyles} from './ForgotPasswordStyle.styles';
import {H5, IMAGE_TABLE_ALT} from '@/utils/constants';
import SuccessIcon from '@icons/successfully.svg';

interface ForgotPasswordStep1Props {
	onCloseModal: () => void;
}
const ForgotPasswordStep5 = ({onCloseModal}: ForgotPasswordStep1Props) => {
	return (
		<Box sx={forgotPasswordModalStyles.content}>
			<Box sx={forgotPasswordModalStyles.iconWrap}>
				<img src={SuccessIcon} alt={IMAGE_TABLE_ALT} />
			</Box>
			<Box sx={forgotPasswordModalStyles.contentWrap}>
				<Typography variant={H5} sx={forgotPasswordModalStyles.title}>
					New Password Created
				</Typography>
				<Typography sx={forgotPasswordModalStyles.description}>Please use your new password to log in.</Typography>
			</Box>
			<Box sx={forgotPasswordModalStyles.btnWrap}>
				<Button sx={forgotPasswordModalStyles.btn} title="Log In" onClick={onCloseModal} />
			</Box>
		</Box>
	);
};

export default ForgotPasswordStep5;
